var TimeUtil = function(){

	var epoch = 0;
	var serverTime = 0;
	var date = null;

	var fallBackScenario = function(){
		date = new Date();
		epoch = date.getTime();
		serverTime = Math.round(epoch / 1000);
	};

	this.setDate = function(inDate){
		try{
			if(inDate){
				date = inDate;
				epoch = date.getTime();
				serverTime = Math.round(epoch / 1000);
			}
		}catch(e){}

		return this;
	}

	this.setEpoch = function(inEpoch){
		try{
			if(typeof inEpoch === "string" && !isNaN(inEpoch)){
				epoch = (inEpoch.length <= 10) ? Number(inEpoch) * 1000 : Number(inEpoch);
			}else if(typeof inEpoch === "number"){
				epoch = (inEpoch.toString().length <= 10) ? (inEpoch*1000) : inEpoch;
			}

			serverTime = Math.round(epoch / 1000);
			date = new Date(epoch);
		}catch(e){}

		return this;
	}

	this.setServerTime = function(inServerTime){

		try{
			if(typeof inServerTime === "string" && !isNaN(inServerTime)){
				serverTime = (inServerTime.length > 10) ? Math.round(Number.parseInt(inServerTime) / 1000) : Number.parseInt(inServerTime);
			}else if(typeof inEpoch === "number"){
				serverTime = (inServerTime.toString().length > 10) ? Math.round(inServerTime / 1000) : inServerTime;
			}

			epoch = serverTime * 1000;
			date = new Date(epoch);
		}catch(e){}

		return this;
	}

	this.getDate = function(){
		if(!date){
			fallBackScenario();
		}

		return date;
	}

	this.getEpoch = function(){
		if(epoch <= 0){
			fallBackScenario();
		}


		return epoch;
	}

	this.getServerTime = function(){
		if(serverTime <= 0){
			fallBackScenario();
		}

		return serverTime;
	}
};

export default TimeUtil;


// WEBPACK FOOTER //
// ./src/util/TimeUtil.js